import React from 'react';

import './FormStyles.css';
import './Input.css';
import MagnifyingGlass from '../../images/magnifying_glass.png';

class SearchInputBase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      touched: false,
      focused: false,
      errors: [],
      userInputValue: '',
    };
  }

  handleBlur = (evt) => {
    const { onBlur } = this.props;

    this.setState({
      touched: true,
      focused: false,
    });

    if (onBlur) {
      onBlur(evt);
    }
  }

  handleFocus = (evt) => {
    const { onFocus } = this.props;

    this.setState({
      focused: true,
    });

    if (onFocus) {
      onFocus(evt);
    }
  }

  handleChange = (evt) => {
    const { onSubmit } = this.props;
    this.setState({ userInputValue: evt.target.value });
    if (evt.target.value === '') {
      onSubmit(null);
    }
  }

  searchChange = () => {
    const { onSubmit } = this.props;
    if (onSubmit && (this.state.userInputValue !== null)) {
      onSubmit(this.state.userInputValue);
    }
  }

  validate() {
    const { required } = this.props;

    const errors = {};

    if (required) {
      if (!this.state.value) {
        errors.required = 'vaadittu kenttä';
      }
    }

    return Object.keys(errors).length ? errors : null;
  }

  get attributes() {
    const { className, required } = this.props;

    const errors = this.validate(this.state.value);
    const showErrors = errors && this.state.touched;

    return {
      'iso-latin-only': '',

      ...this.props,

      className: (className ? `${className} ` : '')
        + (showErrors && !this.state.focused ? 'form-input-error' : ''),

      'aria-required': !!required,
      'aria-invalid': (showErrors && !this.state.focused),

      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onChange: this.handleChange,
    };
  }

  render() {
    if (true) throw new Error('SearchInputBase.render function not implemented');
  }
}

class SearchInput extends SearchInputBase {
  isButton() {
    const { type } = this.props;

    return (type === 'submit' || type === 'reset');
  }

  handleResetButton = () => {
    const { onSubmit } = this.props;
    onSubmit(undefined);
    document.getElementsByClassName('srch-box').item(0).value = null;
  }

  resetAllFilters = () => {
    const { resetFilter, onSubmit } = this.props;
    resetFilter(true);
    onSubmit(undefined);
    document.getElementsByClassName('srch-box').item(0).value = null;
  }

  render() {
    const { resetSearchTerm, resetbutton } = this.props;
    let attributes = this.attributes;
    const { className } = attributes;
    attributes = {
      type: 'text',

      ...attributes,

      className: `text-5 ${!this.isButton() ? 'form-input srch-box' : 'form-button form-input-shadow '}${className}`,
    };

    return (

      <form className="inputWithButton">
        <div className="search-box-container">
          <span onClick={this.handleResetButton} className={resetSearchTerm ? 'search-reset-btn-show' : 'search-reset-btn-hide'}> X </span>
          <input {...attributes}
                 onKeyPress={(event) => {
                   if (event.key === 'Enter') {
                     event.preventDefault();
                     this.searchChange();
                   }
                 }} />
          <img src={MagnifyingGlass} alt="" onClick={() => this.searchChange()} />
        </div>
        <div className="floatRightResetButton">
          <button className="button-link primary-color inline-block bold"
                  onClick={this.resetAllFilters}
                  type="button">
            {resetbutton}
          </button>
        </div>
      </form>

    );
  }
}

export { SearchInputBase };
export default SearchInput;
